import {
	defaultDataFormats,
	defaultLocalizerFactory,
	defaultValueConversion,
	Locale,
	ValueConversion
} from "@com.mgmtp.a12.utils/utils-localization/lib/main";
import { DocumentModel } from "@com.mgmtp.a12.kernel/kernel-md-facade";

import { ModulFState } from "../app/slices/store";
import { externalEnumProvider } from "../modules/processOverview/components/externalEnumerationProvider";

import { getDocumentModelElement } from "./modelElementHelper";

/**
 * An implementation of a custom A12 overview engine converter that resolves external enumeration values.
 * @param locale The current locale
 * @param documentModel The document model used in the overview engine
 * @param state current state
 */
export const createExternalEnumLocalizerContextValue = (
	locale: Locale,
	state: ModulFState,
	documentModel?: DocumentModel
) => {
	if (!documentModel) {
		return;
	}

	const dataFormats = defaultDataFormats(locale);
	const defaultConversion = defaultValueConversion(dataFormats);

	const conversion: ValueConversion = {
		...defaultConversion,
		formatValue(value, outputFormat) {
			if (!outputFormat.modelPath) {
				return defaultConversion.formatValue(value, outputFormat);
			}

			const element = getDocumentModelElement(documentModel, outputFormat.modelPath);

			const externalEnum = element?.annotations?.find(e => e.name === "externalEnum")?.value;

			if (externalEnum && typeof value === "string") {
				const provider = externalEnumProvider(state);
				return provider(externalEnum)?.[value]?.de ?? "";
			} else {
				return defaultConversion.formatValue(value, outputFormat);
			}
		}
	};
	const localizer = defaultLocalizerFactory({ locale, conversion, dataFormats });

	return { locale, dataFormats, conversion, localizer };
};
